import EntityModel from '@/common/models/entity-model';
import ContactModel from '@/common/models/contact-model';

export default class BankAccountModel extends EntityModel {
    hydrate({
        id = null,
        accountType = null,
        routingNumber = null,
        status = null,
        bankName = null,
        customerId = null,
        createdTime = null,
        updatedTime = null,
        customFields = null,
        address,
        name = null,
        contactId = null,
        last4 = null,
    } = {}) {
        this.id = id;
        this.accountType = accountType;
        this.routingNumber = routingNumber;
        this.status = status;
        this.bankName = bankName;
        this.customerId = customerId;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.customFields = customFields;
        this.address = new ContactModel(address);
        this.name = name;
        this.contactId = contactId;
        this.last4 = last4;
    }
}
